import { createContext, useContext } from 'react';

/**
 * True when a component is rendered inside a `Sheet` (gorhom bottom sheet).
 * `TextField` reads this to swap in gorhom's `BottomSheetTextInput`, which lets
 * the detached sheet track the focused input and lift above the keyboard.
 */
export const SheetContext = createContext(false);

export const useInSheet = () => useContext(SheetContext);
